module.exports = __webpack_public_path__ + "static/img/title.6cc0075.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/feature6/title.png
// module id = DWfP
// module chunks = 7